export const MuiContainer = {
  styleOverrides: {
    maxWidthLg: {
      '@media (min-width: 1280px)': {
        maxWidth: '1340px'
      }
    }
  }
}
